<template>
  <td
    class="border-b border-t border-navy first-of-type:rounded-l-[10px] first-of-type:border-l last-of-type:rounded-r-[10px] last-of-type:border-r"
  >
    <slot />
  </td>
</template>
